module.exports = "import React from 'react';\nimport {blue500, red500, greenA200} from 'material-ui/styles/colors';\nimport SvgIcon from 'material-ui/SvgIcon';\n\nconst iconStyles = {\n  marginRight: 24,\n};\n\nconst HomeIcon = (props) => (\n  <SvgIcon {...props}>\n    <path d=\"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z\" />\n  </SvgIcon>\n);\n\nconst SvgIconExampleSimple = () => (\n  <div>\n    <HomeIcon style={iconStyles} />\n    <HomeIcon style={iconStyles} color={blue500} />\n    <HomeIcon style={iconStyles} color={red500} hoverColor={greenA200} />\n  </div>\n);\n\nexport default SvgIconExampleSimple;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/SvgIcon/ExampleSimple.js
 ** module id = 1067
 ** module chunks = 0
 **/